import instance from '../utils/axios';

class DealerOrderService {

    async getDealerOrderList(pageIndex, keyword) {
        return await instance.post('/erp/radOrder/getDealerList', {
            isMobile: "true",
            pageSize: 10,
            pageIndex: pageIndex,
            fuzzySearch: keyword,
            searchField_string_serialNumber: keyword,
            searchField_string_dealerName: keyword,
            searchField_string_customerId: keyword,
            searchField_string_customerMobile: keyword,
            searchField_string_customerAddress: keyword,
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            sortField: 'createTime',
            sort: 'desc',
			dictionaryNames: 'orderStatus.rad_order_status'
        });
    }
    async getRadOrderList(pageIndex, keyword, orderStatus, startTime, endTime) {
        return await instance.post('/erp/radOrder/getDealerList', {
            isMobile: "true",
            orderStatus: orderStatus,
            startTime: startTime,
            endTime: endTime,
            pageSize: 10,
            pageIndex: pageIndex,
            fuzzySearch: keyword,
            searchField_string_serialNumber: keyword,
            searchField_string_customerId: keyword,
            searchField_string_customerName: keyword,
            searchField_string_arrivalMobile: keyword,
            searchField_string_arrivalAddress: keyword,
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            sortField: 'createTime',
            sort: 'desc',
            dictionaryNames: 'orderStatus.rad_order_status,creatorId.base_staff'
        });
    }

    async getMyRadOrderList(pageIndex, keyword, orderStatus, dealerId) {
        return await instance.post('/erp/radOrder/mobile/getRadOrderList', {
            dealerId: dealerId,
            orderStatus: orderStatus,
            pageSize: 10,
            pageIndex: pageIndex,
            fuzzySearch: keyword,
            searchField_string_serialNumber: keyword,
            searchField_string_customerId: keyword,
            searchField_string_customerName: keyword,
            searchField_string_arrivalMobile: keyword,
            searchField_string_arrivalAddress: keyword,
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            sortField: 'createTime',
            sort: 'desc',
            dictionaryNames: 'orderStatus.rad_order_status,creatorId.base_staff'
        });
    }
    async getMyDealerRankOrderList(pageIndex, dealerId, creatorId, startTime, endTime, status) {
        return await instance.post('/erp/radOrder/mobile/getAmountRankOrderList', {
            dealerId: dealerId,
            creatorId: creatorId,
            startTime: startTime,
            endTime: endTime,
            status: status,
            pageSize: 10,
            pageIndex: pageIndex,
            fuzzySearch: "",
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            sortField: 'lastStepCompleteTime',
            sort: 'desc',
            dictionaryNames: 'orderStatus.rad_order_status,creatorId.base_staff,dealerId.rad_dealer'
        });
    }

    async getRadOrderInfoById (orderId){
        return await instance.post('/erp/radOrder/getOrderInfo',{orderId: orderId});
    }

    async getRadOrderDetailList(pageIndex, orderId, tableName) {
        return await instance.post('/erp/radOrder/getDealerDetail?dealerId='+ orderId +
                        '&type=mobile&tableName=' + tableName, {
            pageSize: 10,
            pageIndex: pageIndex,
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            sortField: 'createTime',
            sort: 'asc',
            dictionaryNames: 'radId.rad_sku,caliber.dict_rad_caliber,color.dict_rad_color,waterFlow.dict_rad_flowin_method'
        });
    }

    async deleteOrderDetailById (orderId, orderDetailId){
        return await instance.post('/erp/radOrder/mobile/deleteOrderDetailById',{orderId: orderId, detailId: orderDetailId});
    }

    async deleteOrderById (orderId){
        return await instance.post('/erp/radOrder/mobile/deleteOrderById',{orderId: orderId});
    }

    async getSkuList(pageIndex, keyword) {
        return await instance.post('/erp/sku/getSkuList', {
            pageSize: 10,
            pageIndex: pageIndex,
            fuzzySearch: keyword,
            searchField_string_name: keyword,
            searchField_string_typeName: keyword,
            searchField_string_heightName: keyword,
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            sortField: 'createTime',
            sort: 'asc',
            dictionaryNames: 'categoryType.dict_sku_category_type'
        });
    }
    async getRadSkuList(pageIndex, categoryId, groupId, isLeader, keyword) {
        return await instance.post('/erp/sku/getRadSkuList?categoryId='+ categoryId
            +'&priceGroupId='+groupId+'&isLeader=' + isLeader, {
            pageSize: 10,
            pageIndex: pageIndex,
            fuzzySearch: keyword,
            searchField_string_name: keyword,
            searchField_string_code: keyword,
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            sortField: 'createTime',
            sort: 'desc',
        });
    }

    async getRadSkuById (skuId, priceGroupId, heightId){
        return await instance.post('/erp/sku/getRadSkuById',{radId: skuId, priceGroupId: priceGroupId, heightId: heightId});
    }

    async getRadSkuDictFilterById (skuId){
        return await instance.post('/erp/sku/getSkuDictFilter',{radId: skuId});
    }

    async getRadSkuInfoByParam (heightId,centerSpacing,color,waterFlow,caliber,groupId,radId){
        return await instance.post('/erp/sku/getRadSkuInfoByParam',{
            heightId: heightId,
            centerSpacing: centerSpacing,
            color: color,
            waterFlow: waterFlow,
            caliber: caliber,
            groupId: groupId,
            radId: radId
        });
    }

    async getPartsList(pageIndex, keyword) {
        return await instance.post('/erp/sku/getPartsList', {
            pageSize: 10,
            pageIndex: pageIndex,
            fuzzySearch: keyword,
            searchField_string_name: keyword,
            searchField_string_parentName: keyword,
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            sortField: 'categoryTime',
            sort: 'asc',
            dictionaryNames: 'brandId.psi_sku_category'
        });
    }

    async getSkuInitInfo (type, parentId, categoryId){
        return await instance.post('/erp/skuCart/getInitInfo',{type:type, parentId: parentId, categoryId: categoryId});
    }

    async getPsiSkuById (skuId){
        return await instance.post('/erp/skuCart/getPsiSku',{skuId: skuId});
    }

    async getCartQuantity (ids){
        return await instance.post('/erp/skuCart/getCartQuantity', {ids: ids});
    }

    async getCartAmount (ids){
        return await instance.post('/erp/skuCart/getCartAmount', {ids: ids});
    }

    async getDealerInfo (){
        return await instance.post('/erp/dealer/getMyDealer');
    }

    async getSkuCartList(pageIndex) {
        return await instance.post('/erp/skuCart/getList', {
            pageSize: 10,
            pageIndex: pageIndex,
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            sortField: 'createTime',
            sort: 'desc',
            dictionaryNames: 'radId.v_rad_sku_psi_category,radCategory.v_sku_category,skuId.psi_sku,centerCategory.dict_rad_center_category,caliber.dict_rad_caliber,color.dict_rad_color,waterFlow.dict_rad_flowin_method,custom_dropdown_2.dict_order_free_bool'
        });
    }

    async getCartDescriptionList (type){
        return await instance.post('/erp/skuCart/getCartDescriptionList', {type: type});
    }

    async getCartInfoById (cartId, type){
        return await instance.post('/erp/skuCart/getCartInfo', {cartId: cartId, type: type});
    }

    async saveSkuInfo(data) {
        return await instance.post("/erp/skuCart/saveSkuCart", {data: JSON.stringify(data)});
    }

    async updateSkuCartInfo(cartId, quantity) {
        return await instance.post("/erp/skuCart/updateSkuCart", {uuid: cartId, quantity: quantity});
    }

    async deleteCartItemByIds (ids){
        return await instance.post('/erp/skuCart/deleteCartItems', {ids: ids});
    }

    async getIntoOrder (ids){
        return await instance.post('/erp/skuCart/createOrder', {ids: ids});
    }

    async settleSkuOrder (customerName, arrivalAddress, arrivalMobile, ids){
        return await instance.post('/wf/orderCart/settlement', {
            customerName: customerName,
            arrivalAddress: arrivalAddress,
            arrivalMobile: arrivalMobile,
            detailIds: ids
        });
    }

    async getRadDealerRankList(pageIndex, name, type, startTime, endTime, status) {
        return await instance.post('/erp/radOrder/mobile/getMyDealerAmountRank?type='+ type
            +'&name='+name+'&startTime=' + startTime + '&endTime=' + endTime + '&status=' + status, {
            pageSize: 10,
            pageIndex: pageIndex,
            fuzzySearch: "",
            expressions: '[{"field": "数量", "expression": "count(1)"},{"field": "amount", "expression": "sum(amount)"}]',
            sortField: 'amount',
            sort: 'desc',
            dictionaryNames: 'dealerId.rad_dealer,creatorId.base_staff'
        });
    }

    async getSkuInventoryList(pageIndex, keyword, param) {
        let data = {
            isMobile: "true",
            pageSize: 10,
            pageIndex: pageIndex,
            fuzzySearch: keyword,
            searchField_string_brandName: keyword,
            searchField_string_categoryName: keyword,
            searchField_string_skuName: keyword,
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            sortField: 'brandId desc, radCategory desc, radId desc',
            dictionaryNames: 'radId.rad_sku,radCategory.rad_sku_category,centerCategory.dict_rad_center_category,caliber.dict_rad_caliber,color.dict_rad_color,waterFlow.dict_rad_flowin_method,position.rad_position,custom_dropdown_2.dict_order_free_bool'
        };
        _.each(param, function (index, item) {
            if(param[item]){
                if(item == "pieces"){
                    data.searchField_number_pieces = param.pieces + "|" + param.pieces;
                }else if(item == "centerSpacing" || item == "isSpecials"
                    || item == "custom_text_1" || item == "custom_text_4"
                    || item == "custom_text_2" || item == "custom_text_3"){
                    data["searchField_string_"+item] = "1|"+param[item];
                }else {
                    data["searchField_dictionary_"+item] = param[item];
                }
            }
        });
        return await instance.post('/erp/barcode/getStockList', data);
    }

    async getPartsInventoryList(pageIndex, keyword, param) {
        let data = {
            pageSize: 10,
            pageIndex: pageIndex,
            fuzzySearch: keyword,
            searchField_string_parentName: keyword,
            searchField_string_categoryName: keyword,
            searchField_string_skuName: keyword,
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            sortField: 'brandId desc, radCategory desc, radId desc, skuId desc',
            dictionaryNames: 'brandId.psi_sku_category,radId.psi_sku_category,radCategory.psi_sku_category,skuId.psi_sku'
        };
		param.radCategory = param.skuCategory || "";
	    param.radId = param.skuRadId || "";
	    param.skuCategory = "";
	    param.skuRadId = "";
	    param.custom_text_1 = "";
	    param.custom_text_2 = "";
	    param.custom_text_3 = "";
	    param.custom_text_4 = "";
	    param.custom_dropdown_2 = "";
	    param.pieces = "";
	    param.centerCategory = "";
	    param.centerSpacing = "";
	    param.color = "";
	    param.waterFlow = "";
	    param.isSpecials = "";
	    param.caliber = "";
        _.each(param, function (index, item) {
            if(param[item]){
                data["searchField_dictionary_"+item] = param[item];
            }
        });
        return await instance.post('/erp/sku/getPartsStockList', data);
    }

    async getSearchInitInfo (type){
        return await instance.post('/erp/sku/getSearchInitInfo',{type:type});
    }
}
export default new DealerOrderService();